'use strict';

var Json_decode = require("@glennsl/bs-json/lib/js/src/Json_decode.js");
var Url$PvpcontrollerWeb = require("./Url.js");
var Request$PvpcontrollerWeb = require("./Request.js");
var EditModeService$PvpcontrollerWeb = require("./EditModeService.js");

function changelogResponse(json) {
  return {
          status: Json_decode.field("status", Json_decode.$$int, json),
          changes: Json_decode.field("changes", (function (param) {
                  return Json_decode.array(EditModeService$PvpcontrollerWeb.Decode.change, param);
                }), json),
          totalSize: Json_decode.field("totalSize", Json_decode.$$int, json)
        };
}

function getChangelog(skip, limit, cb) {
  var skip$1 = String(skip);
  var limit$1 = String(limit);
  return Request$PvpcontrollerWeb.getWithDecoder(Url$PvpcontrollerWeb.pvpcapi + "/api/recentchangelog/" + skip$1 + "/" + limit$1, (function (response) {
                var match = changelogResponse(response);
                return {
                        TAG: /* Ok */0,
                        _0: {
                          changes: match.changes,
                          totalSize: match.totalSize
                        }
                      };
              }), cb);
}

exports.getChangelog = getChangelog;
/* Url-PvpcontrollerWeb Not a pure module */
